import CryptoJS from "crypto-js";
import { APP } from '../constant';

export const Decryption = (data) => {
    try {
        return process.env.REACT_APP_ENC_KEY ? JSON.parse(CryptoJS.AES.decrypt(data, process.env.REACT_APP_ENC_KEY).toString(CryptoJS.enc.Utf8)) : data;
    } catch {
        return false;
    }
};
export const Encryption = (data) => process.env.REACT_APP_ENC_KEY ? CryptoJS.AES.encrypt(JSON.stringify(data), process.env.REACT_APP_ENC_KEY).toString() : data;
export const DoubleEncryption = (data) => Encryption(btoa(Encryption(data)));
export const DoubleDecryption = (data) => Decryption(atob(Decryption(data)));
export const setLocal = (key, value) => localStorage.setItem(key, Encryption(value));
export const getLocal = (key) => Decryption(localStorage.getItem(key));

export const socketHandler = (response) => {
    if (typeof response === 'string') return Decryption(response);
    else return response;
}

export const createCookie = (name, value, day = APP.COOKIE_DAYS) => {
    const expiryDate = new Date(Date.now() + day * 24 * 60 * 60 * 1000).toISOString();
    const domains = ['superworks.com', 'superworks.app', 'superworks.net', 'localhost'];
    const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    const options = `path=/; expires=${expiryDate}; max-age=${day * 24 * 60 * 60}; SameSite=Lax${isSecure ? '; Secure' : ''}`;

    domains.forEach(domain => {
        document.cookie = `${name}=${value}; domain=${domain}; ${options}`;
    });
};
export const getCookie = (name) => {
    let nameEq = name + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(nameEq) === 0) {
            return c.substring(nameEq.length, c.length);
        }
    }
    return '';
};
export const eraseCookie = (name) => {
    createCookie(name, '', -1);
    const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax${isSecure ? '; Secure' : ''}`;
};
export const checkCookie = (name) => {
    return getCookie(name)?.length !== 0;
};
export const deleteAllCookies = () => {
    let cookies = document.cookie.split(';');
    const isSecure = typeof window !== 'undefined' && window.location.protocol === 'https:';
    const secureFlag = isSecure ? '; Secure' : '';
    for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i];
        let eqPos = cookie.indexOf('=');
        let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax' + secureFlag;
    }
};
